<section class="flex flex-col gap-3.5 lg:max-h-40 xl:max-h-96 overflow-y-auto">
    <span class="text-base font-medium sticky top-0 bg-white z-10">{{
        'project' | transloco: { COUNT: totalProjectsCount() }
    }}</span>
    <div class="flex flex-col gap-1">
        @if (projects()) {
            <ul class="flex flex-col list-none p-0 gap-1 m-0">
                @for (
                    project of showAll() || totalProjectsCount() < minDisplay
                        ? projects()!
                        : projects()!.slice(0, minDisplay);
                    track project.id
                ) {
                    <li>
                        <fa-icon
                            class="mr-2"
                            [icon]="['fas', 'circle-small']"
                            [style]="{ color: project.color }" />

                        <span class="text-base">{{ project.name }}</span>
                    </li>
                } @empty {
                    <li class="flex p-2">
                        <span>-</span>
                    </li>
                }
            </ul>

            @if (totalProjectsCount() > minDisplay) {
                <app-button
                    iconSize="xs"
                    [icon]="['fas', showAll() ? 'chevron-up' : 'chevron-down']"
                    [iconPosition]="IconPosition.END"
                    [label]="(showAll() ? 'displayLess' : 'displayMore') | transloco"
                    [type]="ButtonType.UNDERLINE"
                    (onClick)="toggleShow()" />
            }
        }
    </div>
</section>
